import { render, staticRenderFns } from "./ContactMoneyQuotes.vue?vue&type=template&id=1f36f7ca&scoped=true"
import script from "./ContactMoneyQuotes.vue?vue&type=script&lang=js"
export * from "./ContactMoneyQuotes.vue?vue&type=script&lang=js"
import style0 from "./ContactMoneyQuotes.vue?vue&type=style&index=0&id=1f36f7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36f7ca",
  null
  
)

export default component.exports